import type { ITradeInVehicle, IVehicleMake, IVehicleModel, IVehicleTrim } from '@makemydeal/dr-activities-common';
import type { SciTradeInComponentState } from '../../types/TradeInState';

import { getInitialState as getTradeInInitialState } from '@makemydeal/dr-activities-tradein';

const initialVehicleMake: IVehicleMake = {
    id: '',
    name: ''
};

const initialVehicleModel: IVehicleModel = {
    id: '',
    name: ''
};

const initialVehicleTrim: IVehicleTrim = {
    id: '',
    name: '',
    vehicleId: ''
};

export const initialVehicle: ITradeInVehicle = {
    color: '',
    interiorColor: '',
    condition: '',
    make: initialVehicleMake,
    mileage: 0,
    model: initialVehicleModel,
    trim: initialVehicleTrim,
    vin: '',
    year: ''
};

/**
 * Returns the initial Redux state for the Trade-In activity from dr-activities-tradein,
 * to override vehicle.condition which is not correctly set for sales-checkin
 */
export const getInitialState = (): SciTradeInComponentState => {
    const tradeinInitialState = getTradeInInitialState();
    return {
        ...tradeinInitialState,
        vehicle: {
            ...(tradeinInitialState.vehicle as ITradeInVehicle),
            condition: ''
        },
        saved: {
            ...(tradeinInitialState.saved as any),
            vehicle: {
                ...(tradeinInitialState.saved?.vehicle as ITradeInVehicle),
                condition: ''
            }
        },
        loanStepPending: false,
        loanStepAnswered: false
    };
};
